import CommonModal from '@/components/Common/Modals';
import { RoutingProvider } from './RoutingProvider';
import { Toaster } from 'react-hot-toast';
import AuthDebug from '@/components/Auth/AuthDebug';
import { DEBUG_MODE } from '@/constants';
import { useSocketLifecycle } from '@/realtime/useSocketLifecycle';

export const AppProvider = () => {
  // Manage socket connection lifecycle based on auth token
  try {
    useSocketLifecycle();
  } catch {
    // noop: sockets remain opt-in if lifecycle hook fails in non-socket envs
  }
  return (
    <>
      <Toaster
        position={'top-center'}
        reverseOrder={false}
        gutter={1}
        toastOptions={{ duration: 5000 }}
      />
      <CommonModal />
      <RoutingProvider />
      {DEBUG_MODE && <AuthDebug />}
    </>
  );
};
